import { collectGroupLeafItems } from '@/utils/presence-groups';

import { isEnrichmentOutsideCut, TEnrichmentTimeRange } from './is-enrichment-outside-cut';

type TLabelledEnrichment = TEnrichmentTimeRange & { entity_label?: string };

/**
 * Names the offending presences so a warning can list what the reviewer cannot
 * see on screen. Labels are de-duplicated because a group repeats its own label
 * on every leaf.
 */
function collectOutsideCutLabels<T extends TLabelledEnrichment>(
  groups: ({ children?: T[] } | T)[],
  cutStart: Date | null,
  cutEnd: Date | null
): string[] {
  const labels = groups
    .flatMap(group => collectGroupLeafItems<T>(group))
    .filter(item => isEnrichmentOutsideCut(item, cutStart, cutEnd))
    .map(item => item.entity_label)
    .filter((label): label is string => Boolean(label));

  return Array.from(new Set(labels));
}

export { collectOutsideCutLabels };
